import React, { useState } from "react";
import SEO from "../components/SEO";
import HeroInner from "../components/HeroInner/HeroInner";
import Services from "../components/Services";
import ChatBot from "../components/ChatBot";
import GlobalScripts from "../components/GlobalScripts";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer";
import Tooltip from "../components/Tooltip";
import ContactModal from "../components/ContactModal/ContactModal";
import "./DesarrolloWeb.css";

function Ecommerce() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <SEO
        title="E-Commerce | WooCommerce y PrestaShop"
        description="Tiendas online optimizadas para vender con WooCommerce y PrestaShop. Incrementa tus ventas con un E-Commerce rápido y seguro."
        url="https://juancarlosmancharamos.ar/ecommerce"
      />

      <Menu />

      <HeroInner
        title="E-Commerce"
        subtitle="Tiendas online optimizadas para escalar y vender 24/7"
        bg="/assets/images/bg-dev.jpg"
      />

      <section className="container dev-section">
        <div className="dev-inner-wrap">
          
          {/* Encabezado y Texto Principal (Estilo limpio sin imagen) */}
          <div className="dev-header">
            <div className="dev-intro-content">
              <h2 className="dev-title">Tu Negocio Abierto al Mundo, 24/7</h2>
              <p className="dev-lead">
                Desarrollo plataformas de E-Commerce de alto rendimiento utilizando <strong>WooCommerce y PrestaShop</strong>. Transformo tu catálogo de productos en una máquina de ventas automatizada, segura y extremadamente fácil de administrar.
              </p>
              <p>
                Un negocio digital exitoso va mucho más allá de un diseño atractivo. Me enfoco en la experiencia de usuario (UX), la velocidad de carga extrema y la optimización de la tasa de conversión (CRO) para reducir el abandono de carritos y maximizar tus ingresos desde el primer día.
              </p>
            </div>
          </div>

          {/* Cuadrícula de Características con Iconos (Enfocados en Tienda Online) */}
          <div className="dev-features">
            <div className="dev-feature-card">
              <div className="dev-icon">
                {/* Icono de Carrito de Compras */}
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
              </div>
              <h3>Plataformas Líderes</h3>
              <p>Desarrollo robusto sobre WooCommerce y PrestaShop, garantizando flexibilidad, soporte global y un panel de control amigable para ti.</p>
            </div>

            <div className="dev-feature-card">
              <div className="dev-icon">
                {/* Icono de Tarjeta de Crédito (Pagos) */}
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg>
              </div>
              <h3>Pagos y Envíos</h3>
              <p>Integración nativa con pasarelas de pago (MercadoPago, Stripe, PayPal) y empresas de logística para calcular envíos en tiempo real.</p>
            </div>

            <div className="dev-feature-card">
              <div className="dev-icon">
                {/* Icono de Gráfico Ascendente (Conversión) */}
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>
              </div>
              <h3>Optimización CRO</h3>
              <p>Diseño enfocado 100% en la conversión. Pasos de compra simplificados (One-Click Checkout) para reducir drásticamente los carritos abandonados.</p>
            </div>

            <div className="dev-feature-card">
              <div className="dev-icon">
                {/* Icono de Caja/Inventario */}
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
              </div>
              <h3>Gestión Automatizada</h3>
              <p>Sincronización de inventario, facturación automática y notificaciones transaccionales para que tu tienda funcione en piloto automático.</p>
            </div>
          </div>

          {/* Banner de Llamada a la Acción (CTA) llamando al Modal */}
          <div className="dev-cta-banner">
            <h3>¿Listo para multiplicar las ventas de tu negocio?</h3>
            <p>Hablemos de tu catálogo y diseñemos la tienda online que tu marca merece.</p>
            <button 
              onClick={() => setIsModalOpen(true)} 
              className="dev-btn-primary" 
              style={{border: 'none', cursor: 'pointer', fontFamily: 'inherit'}}
            >
              Cotizar Tienda Online
            </button>
          </div>
          
        </div>
      </section>

      {/* Sección + servicios unificada para que el espaciado sea perfecto */}
      <section id="abt-lnk" className="center-first">
        <div className="gp no-tpgp btm-spc130">
          <div className="container">
            <div className="skls-wrp2 ovrlp-60 text-center">
              <div className="skls-inr">
                <h2 itemProp="headline">
                  + servicios
                </h2>
              </div>
              <Services />
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
      <ChatBot />
      <Tooltip />
      <GlobalScripts />

      {/* Aquí inyectamos el Modal de Contacto */}
      <ContactModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        defaultService="E-Commerce" 
      />
    </>
  );
}

export default Ecommerce;